import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { CUSTOMER_FEEDBACKS_PATH } from "utils/constants/paths";

const CustomerFeedback = Loadable(React.lazy(() => import("./View")));

export const CustomerFeedbackRoute: IRouteItem = {
  path: CUSTOMER_FEEDBACKS_PATH,
  iconName: "Star",
  element: React.createElement(CustomerFeedback),
  name: "Customer Feedbacks",
  accessKeys: ["SuperAdmin", "Admin", "Analytics", "Content"],
};
